import { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'

import { NoResourcesAvailable } from 'components/NoResourcesAvailable'

const NoReadPermission: FunctionComponent = () => {
  const { t } = useTranslation()

  return (
    <NoResourcesAvailable
      title={t('secrets.oauthListing.noReadPermission.title')}
      supportText={t('secrets.oauthListing.noReadPermission.content')}
      data-testid="no-read-permission-oauth"
    />
  )
}

export default NoReadPermission
